export const loadScript = (jsUrl = '') => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = jsUrl;
  document.getElementsByTagName('head')[0].appendChild(script);
};
